import { css } from 'styled-components';
import { map } from '../../breakpoint';
const validTextAlignValues = [
    'left',
    'center',
    'right',
    'start',
    'end'
];
// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types
export const textAlign = ()=>css`
  ${({ textAlign })=>map(textAlign, (val)=>val && css`
          text-align: ${val === 'left' || val === 'start' ? 'start' : val === 'right' || val === 'end' ? 'end' : val};
        `)};
`;

//# sourceMappingURL=textAlign.js.map